import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostBinding,
  Input,
  Inject,
} from '@angular/core';
import { PG_FIELD_OPTIONS_TOKEN, PgFieldOptions } from '../pg-field-options';

export enum IconDisplayOption {
  HIDE_MOBILE,
  SHOW_ALWAYS,
}

@Component({
  selector: 'pg-prefix-icons, grit-prefix-icons',
  templateUrl: './pg-prefix-icons.component.html',
  styleUrls: ['./pg-prefix-icons.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PgPrefixIconsComponent implements OnInit {
  @HostBinding('class.pg-prefix-icons')
  @HostBinding('class.grit-prefix-icons')
  _classPrefixIcons = true;

  @HostBinding('class.hide-icon-on-mobile')
  get _classHideIconOnMobile() {
    return this.iconDisplayOption === IconDisplayOption.HIDE_MOBILE;
  }

  @Input()
  iconDisplayOption: IconDisplayOption;

  constructor(@Inject(PG_FIELD_OPTIONS_TOKEN) public options: PgFieldOptions) {}

  ngOnInit() {
    if (
      this.iconDisplayOption === undefined ||
      this.iconDisplayOption === null
    ) {
      this.iconDisplayOption = this.options.hidePrefixIconsOnMobile
        ? IconDisplayOption.SHOW_ALWAYS
        : IconDisplayOption.HIDE_MOBILE;
    }
  }
}
